import Button from "../components/Shared/Button/Button";
import { Input } from "../components/Shared/Input/AuthInput";

const ResetPassword = () => {
  return (
    <div className="grid min-h-screen place-items-center bg-lightGray py-14">
      <div className="flex w-[716px] flex-col items-center justify-center rounded-[20px] bg-white">
        <picture className="mt-14 mb-8 h-28 w-52">
          <img src="/assets/images/logo.png" alt="" />
        </picture>
        <p className="mb-14 font-inter text-[32px] font-semibold text-black text-opacity-50">
          Reset Password
        </p>
        <div className="w-full px-32">
          <Input placeholder="Email" />
          <picture className="my-9 flex justify-center">
            <img src="/assets/images/captcha.png" alt="" />
          </picture>
          <Button
            text="Reset Password"
            variant="primary"
            className="mb-14 !w-full rounded-lg !py-3"
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
